<template>
  <div>
    <van-tabs v-model="active" @change="toggle" swipeable>
      <van-tab v-for="(item, index) in option" :title="item.title" :name="item.type" :key="index">
      </van-tab>
    </van-tabs>
    <template v-if="active == 0">
      <van-cell v-for="(item, index) in list" :key="index" :value="item.score + '次'">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <van-tag type="danger">{{ index + 1 }}</van-tag>
          <span style="margin-left:10px" class="custom-title">{{ item.value }}</span>
        </template>
      </van-cell>
    </template>
    <template>
      <van-field
        readonly
        clickable
        name="picker"
        :value="ruleForm.name"
        label="一尘版块"
        placeholder="点击选择一尘版块"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="plateList"
          value-key="name"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
    </template>
  </div>
</template>
<script>
import { queryTopHotWord, queryHotPosts, getSectionList } from '@/api/base';
export default {
  data() {
    return {
      active: 0,
      showPicker: false,
      ruleForm: {
        name: null,
      },
      option: [
        { title: '热搜榜', type: 0 },
        { title: '热门帖', type: 1 },
      ],
      list: [],
      plateList: [],
      fetch: queryTopHotWord,
      params: {
        start: 1,
        end: 10,
      },
      page: {
        size: 10,
        current: 1,
      },
    };
  },
  created() {
    this.onLoad();
    this.init();
  },
  methods: {
    init() {
      let str = window.localStorage.getItem('plateList');
      if (str) {
        this.plateList = JSON.parse(str);
      } else {
        getSectionList().then(res => {
          this.plateList = res.data.sort((a, b) => a.sortno - b.sortno);
          this.plateList.map(item => {
            item.children.sort((a, b) => a.sortno - b.sortno);
          });
        });
      }
    },
    toggle(e) {
      console.log(e);
      this.list = [];
      switch (e) {
        case 0:
          this.fetch = queryTopHotWord;
          break;
        case 1:
          this.fetch = queryHotPosts;
          break;
        default:
          break;
      }
      this.onLoad();
    },
    onLoad() {
      this.fetch(this.params).then(res => {
        this.list = res.data;
      });
    },
    onConfirm(value, e) {
      this.ruleFrom.code = this.plateList[e[0]].children[e[1]].code;
      this.ruleForm.name = value;
      this.showPicker = false;
    },
  },
};
</script>
